jQuery(document).on("page.ready", function () {
  $ = jQuery;

  if ($(".insights-overview, .press-overview").length) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;
    if (!isMobile) {
      $(window).load(function () {
        $("#width_tmp_option").html($("#resizing_select option:selected").text());
        $("#resizing_select").width($("#width_tmp_select").width());
      });

      $("#resizing_select").change(function () {
        $("#width_tmp_option").html($("#resizing_select option:selected").text());
        $(this).width($("#width_tmp_select").width());
      });
    }

    var post_type;
    var category;
    // Filter Posts by Category on Select Change
    $(".insights-selector").change(function (e) {
      loadmore_params.current_page = 1;
      post_type = $(this).parents(".post-filter-nav").attr("data-post_type");
      category = $(this).val();

      $(".loadmore").show();

      if ($(".no-mas").length) {
        $(".no-mas").hide();
      } else {
        $(".no-mas").show();
      }

      $(".cat-name").removeClass("active");
      $(this).addClass("active");

      if (category == "all") {
        category = "all";
      }

      data = {
        action: "filterposts",
        category: category,
        post_type: post_type,
      };

      $.ajax({
        url: loadmore_params.ajaxurl,
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          $(".load-cats.loading-dots").show();
        },
        success: function (data) {
          $(".loading-dots").hide();
          if (data) {
            $(".blogpost-container").html(data.posts);
          } else {
            $(".blogpost-container").html("No posts found.");
          }
        },
      });
    });

    // $(".cat-name").on("click", function (e) {
    //   e.preventDefault();
    //   loadmore_params.current_page = 1;
    //   post_type = $(this).parent().attr("data-post_type");
    //   category = $(this).attr("data-category");

    //   if ($(".no-mas").length) {
    //     $(".no-mas").remove();
    //   }

    //   $(".cat-name").removeClass("active");
    //   $(this).addClass("active");

    //   if (category == "all") {
    //     category = "all";
    //   }

    //   data = {
    //     action: "filterposts",
    //     category: category,
    //     post_type: post_type,
    //   };

    //   $.ajax({
    //     url: loadmore_params.ajaxurl,
    //     data: data,
    //     type: "POST",
    //     beforeSend: function (xhr) {
    //       $(".load-cats.loading-dots").show();
    //     },
    //     success: function (data) {
    //       $(".loading-dots").hide();
    //       if (data) {
    //         $(".blogpost-container").html(data.posts);
    //       } else {
    //         $(".blogpost-container").html("No posts found.");
    //       }
    //     },
    //   });
    // });

    // Checks the Current Cat in category.php
    if (typeof currentCat !== "undefined") {
      if (!category) {
        category = currentCat;
      }
    }

    // Load more posts on Button Click
    $(".loadmore").click(function (e) {
      e.preventDefault();

      post_type = $(".filter-nav-container .post-filter-nav").attr("data-post_type");

      var button = $(this),
        data = {
          action: "loadmore",
          query: loadmore_params.posts, // that's how we get params from wp_localize_script() function
          page: loadmore_params.current_page,
          category: category,
          post_type: post_type,
        };

      $.ajax({
        // you can also use $.post here
        url: loadmore_params.ajaxurl, // AJAX handler
        data: data,
        type: "POST",
        beforeSend: function (xhr) {
          $(".load-more.loading-dots").show();
          button.hide();
        },
        success: function (data) {
          if (data) {
            $(".blogpost-container").append(data);
            loadmore_params.current_page++;
            button.show();

            if (loadmore_params.current_page == loadmore_params.max_page) {
              button.hide(); // if last page, remove the button
            }
          } else {
            button.hide(); // if no data, remove the button as well
            $(".load-more-container").append('<p class="no-mas sub-title">That\'s all folks!</p>');
          }

          $(".load-more.loading-dots").hide();
        },
      });
    });

    $(".cat-name").click(function () {
      $(".loadmore").show();
    });

    $(window).on("load", function () {
      // Spinning Icon On Scroll
      var $cog = $("#icon-spin"),
        $body = $("body"),
        bodyHeight = $body.height();

      $(window).scroll(function () {
        $cog.css({
          transform: "rotateY(" + ($(document).scrollTop() / bodyHeight) * 360 + "deg)",
        });
      });
    });
  }
});
